import {ThunkActionType} from 'store/types';
import request from 'api/requests/request';
import {downloadImage} from 'utils';
import {InternalError} from 'utils/error';

import {DEFAULT_ICON} from 'components/List/Item';

import {
  loadWisbitsRequest,
  loadWisbitsFailure,
  loadWisbitsSuccess,
} from './actions';
import {WisbitItem} from '../types';
import {USER_TYPE} from 'containers/ManageUserPage/userType';

export const loadWisbitsThunk =
  (): ThunkActionType => async (dispatch, getState) => {
    dispatch(loadWisbitsRequest());

    try {
      const {app: {user: {id = '', role, organization} = {}} = {}} = getState();

      if (!id) {
        throw new InternalError(
          'Er is iets misgegaan, probeer opnieuw in te loggen',
          true,
          'Auth not found'
        );
      }

      let requestUrl = `/lesson?query=created.id==${id}&order=-created.date&limit=1000`;
      if (role === USER_TYPE.ADMIN.serverAlias && organization) {
        requestUrl = `/lesson?query=organization.id==${organization.id};published==true&order=-created.date&limit=1000`;
      }

      const response = await request(requestUrl);

      const data: WisbitItem[] = [];
      for (let i = 0; i < response.length; i++) {
        const {
          id,
          title,
          published,
          student_count: studentCount,
          image: {id: imageId = undefined} = {},
          created,
        } = response[i];

        const image = await downloadImage(imageId);

        data.push({
          id,
          thumbnailImageData: image || DEFAULT_ICON,
          title,
          published,
          students: !published ? 0 : studentCount,
          contentCreator: created.name,
        });
      }

      dispatch(loadWisbitsSuccess(data));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(loadWisbitsFailure(error));
    }
  };
